import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import SelectDropdown from "../../components-react/SelectDropdown";
import {
  ages,
  fitnessProfileActivityStatuses,
  gender,
  medicalIssues,
  rangeDataUpto285,
  smallRangeDataUpto11,
  smallRangeDataUpto8,
} from "../../common-data/DropdowData";
import {
  calculateBMI,
  calculateBMIForBodyFat,
  calculateBMR,
  calculateBodyFatPercentage,
  calculateDailyCalorie,
  calculateTDEE,
  getBMICategory,
  validateFitnessProfileForm,
} from "./validations/Validations";
import MultiSelect from "../../components-react/MultiSelect";
import {
  fetchDietPreferenceData,
  fetchDietTypesData,
} from "../../../redux/reducers/apiSlice";
import GaugeChart from "react-gauge-chart";
import { BMR, BODYFAT, TDEE } from "../../../exports/Images";
import { commonPostPutApi1 } from "../../../redux/reducers/commonApiSlice";
import { toast } from "react-toastify";
import {
  dietMapping,
  fitnessProfileLogPut,
  memberUpdatePut,
} from "../../../data/ApiEndpoints";
import { fetchAllMembersData } from "../../../redux/reducers/dropdownApiSlice";
import SelectDropdownDynamic from "../../components-react/SelectDropdownDynamic";
import DietFetchAndAssign from "./DietFetchAndAssign";

const FPForm = ({ onCloseModal, userInfoData, callFunction }) => {
  const dispatch = useDispatch();
  const { dietTypesData, dietPreferenceData } = useSelector(
    (state) => state.api
  );
  const { members } = useSelector((state) => state.dropdown);

  const iniDrpdownData = {
    allDietPreferences: [],
    allBodyTypes: [],
  };
  const [allDPDropdownData, setAllDPDropdownData] = useState(iniDrpdownData);
  const iniFormValues = {
    selMember: "",
    selGender: "",
    selMemAge: "",
    selMemHeightInCm: "",
    selMemHeightInFt: "",
    selMemHeightInInc: "",
    memWeight: "",
    memTargetWeight: "",
    memWaist: "",
    memNeck: "",
    memHip: "",
    selBodyType: "",
    selDietPreference: "",
    selActivity: "",
    selMedicalIssue: [],
    otherMedicalIssue: "",
    isCmHeight: false,
    isSmoke: false,
    isDrink: false,
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [bmiValues, setBmiValues] = useState({});
  const [tdeeValues, setTdeeValues] = useState(0);
  const [bmrValues, setBmrValues] = useState(0);
  const [bodyfatValues, setBodyfatValues] = useState({});
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [isFtProfileSuccess, setIsFtProfileSuccess] = useState(false);
  const iniDataValues = {
    dietPackData: [],
    dietSuceesData: [],
  };
  const [dataValues, setDataValues] = useState(iniDataValues);
  const iniInputs = {
    isRecomended: false,
    isExtreame: false,
    dietTpe: "",
  };
  const [recExtInputs, setRecExtInputs] = useState(iniInputs);
  const [isSubmitDF, setIsSubmitDF] = useState(false);
  let notShowBtn = false;

  if (isFtProfileSuccess && !(dataValues.dietPackData?.length > 0)) {
    notShowBtn = true;
  } else if (
    recExtInputs.dietTpe &&
    !(recExtInputs.isRecomended || recExtInputs.isExtreame)
  ) {
    notShowBtn = true;
  }

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    setIsSubmit(false);

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);
    setFormValues({ ...formValues, [name]: value });
  };

  const onSubmit = () => {
    setFormErrors(validateFitnessProfileForm(formValues));
    setIsSubmit(true);
  };

  const handleBack = () => {
    setRecExtInputs(iniInputs);
    setIsSubmitDF(false);
    setIsFtProfileSuccess(false);
  };

  function getDietPreference() {
    dispatch(
      fetchDietPreferenceData({
        pageNo: 1,
        limit: 10,
        queryParameters: "&status=active",
        token: userInfoData?.token,
      })
    );
  }

  function getBodyTypes() {
    dispatch(
      fetchDietTypesData({
        pageNo: 1,
        limit: 10,
        queryParameters: "&status=active",
        token: userInfoData?.token,
      })
    );
  }

  function getMembers(filter) {
    dispatch(
      fetchAllMembersData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  const handleSearchChange = (inputValue) => {
    setSearch(inputValue);
    setPage(1);
  };

  const fetchMoreData = () => {
    if (page + 1 <= totalPages) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const fetchPreviousData = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  function updateMember() {
    const medicalIssues = formValues.selMedicalIssue?.map(
      (goal) => goal.value !== "other" && goal.value
    );
    const medicalIssuesString = medicalIssues.join(", ");
    const dietCatId = dataValues.dietPackData?.[0]?.uid || "";

    const userDataMemberUpdate = {
      uid: formValues.selMember?.info?.uid || "",
      user_uid: formValues.selMember?.info?.user_id || "",
      name: formValues.selMember?.info?.name || "",
      email: formValues.selMember?.info?.email || "",
      dob: formValues.selMember?.info?.dob || "",
      target_duration: formValues.selMember?.info?.target_duration || "",
      location: formValues.selMember?.info?.location || "",
      lat: formValues.selMember?.info?.lat || "",
      long: formValues.selMember?.info?.long || "",
      status: formValues.selMember?.info?.status || "",
      trainer_notes: formValues.selMember?.info?.trainer_notes || "",
      is_completed: formValues.selMember?.info?.is_completed || "",
      preferred_location: formValues.selMember?.info?.preferred_location || "",
      version: formValues.selMember?.info?.version || "",

      age: formValues.selMemAge?.value || "",
      gender: formValues.selGender?.value || "",
      height: formValues.selMemHeightInCm?.value || "",
      weight: formValues.memWeight || "",
      target_weight: formValues.memTargetWeight || "",
      body_type: formValues.selBodyType?.value || "",
      existing_disease: medicalIssuesString || "",
      is_smoking: formValues.isSmoke ? true : false,
      is_drinking: formValues.isDrink ? true : false,
      howactive: formValues.selActivity?.value || "",
      type1: formValues.selBodyType?.value || "",
      type2: formValues.selDietPreference?.value || "",
      neck: formValues.memNeck || "",
      waist: formValues.memWaist || "",

      is_updatev2: 1,
      diet_category_id: dietCatId,
    };

    handleAdd(userDataMemberUpdate, "PUT", memberUpdatePut, "member-update");
  }

  function onAssignDiet() {
    const dietCatId = dataValues.dietPackData?.[0]?.uid || "";
    const subsId = formValues.selMember?.info?.subscription_id || "";

    const userDataDietAssign = {
      user_id: formValues.selMember?.info?.user_id || "",
      diet_category_id: dietCatId,
      subscription_id: subsId,
      is_free: 0,
      is_complementry: 1,
    };

    handleAdd(userDataDietAssign, "POST", dietMapping, "diet-assign");
  }

  const handleAdd = async (requestBody, apiMethod, apiEndpoint, name) => {
    const method = apiMethod;
    const endpoint = apiEndpoint;
    const payload = requestBody;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutApi1({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        if (name === "fitness-profile") {
          setIsFtProfileSuccess(true);
        } else if (name === "diet-assign") {
          updateMember();
          setDataValues((prevs) => ({
            ...prevs,
            dietSuceesData:
              result.payload?.data?.length > 0 ? result.payload.data : [],
          }));
        } else if (name === "member-update") {
          toast.success(result?.payload?.message || "Success!");
          setFormValues(iniFormValues);
          setDataValues(iniDataValues);
          setIsFtProfileSuccess(false);
          onCloseModal();
          callFunction();
        }
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    const filters = {
      page: page,
      limit: 10,
      search: search ? search : "",
      subscription_status: "active",
    };

    getMembers(filters);
  }, [page, search]);

  useEffect(() => {
    if (members?.length > 0) {
      setTotalPages(members[0]?.pagination?.[0]?.pages || 0);
    } else {
      setTotalPages(1);
    }
  }, [members]);

  useEffect(() => {
    if (!formValues.isCmHeight && formValues.selMemHeightInFt?.value) {
      const heightFtInCm = formValues.selMemHeightInFt.value * 30.48; // 1 foot = 30.48 cm
      const heightInchesInCm = formValues.selMemHeightInInc?.value
        ? formValues.selMemHeightInInc.value * 2.54
        : 0; // 1 inch = 2.54 cm
      const totalHeightInCm = (heightFtInCm + heightInchesInCm).toFixed(2);

      setFormValues((prevs) => ({
        ...prevs,
        selMemHeightInCm: { label: totalHeightInCm, value: totalHeightInCm },
      }));
    }
  }, [
    formValues.isCmHeight,
    formValues.selMemHeightInFt,
    formValues.selMemHeightInInc,
  ]);

  useEffect(() => {
    if (formValues.isCmHeight && formValues.selMemHeightInCm?.value) {
      const totalHeightInCm = formValues.selMemHeightInCm.value;
      const heightInFeet = Math.floor(totalHeightInCm / 30.48); // 1 foot = 30.48 cm
      const remainingCm = totalHeightInCm % 30.48;
      const heightInInches = (remainingCm / 2.54).toFixed(2); // 1 inch = 2.54 cm

      setFormValues((prevs) => ({
        ...prevs,
        selMemHeightInFt: { value: heightInFeet, label: heightInFeet },
        selMemHeightInInc: { value: heightInInches, label: heightInInches },
      }));
    }
  }, [formValues.isCmHeight, formValues.selMemHeightInCm]);

  useEffect(() => {
    getDietPreference();
    getBodyTypes();
  }, []);

  useEffect(() => {
    if (dietPreferenceData?.status && dietPreferenceData?.data?.length > 0) {
      const { data } = dietPreferenceData || {};
      const allDPs = data?.map((dp) => ({
        label: dp?.value,
        value: dp?.uid,
      }));
      setAllDPDropdownData((prevs) => ({
        ...prevs,
        allDietPreferences: allDPs,
      }));
    } else {
      setAllDPDropdownData((prevs) => ({
        ...prevs,
        allDietPreferences: [],
      }));
    }

    if (dietTypesData?.status && dietTypesData?.data?.length > 0) {
      const { data } = dietTypesData || {};
      const allDPs = data?.map((dp) => ({
        label: dp?.value,
        value: dp?.uid,
        info: dp,
      }));
      setAllDPDropdownData((prevs) => ({
        ...prevs,
        allBodyTypes: allDPs,
      }));
    } else {
      setAllDPDropdownData((prevs) => ({
        ...prevs,
        allBodyTypes: [],
      }));
    }
  }, [dietPreferenceData, dietTypesData]);

  useEffect(() => {
    if (formValues.selMemHeightInFt?.value && formValues.memWeight) {
      setBmiValues({
        ft: formValues.selMemHeightInFt.value || 0,
        inch: formValues.selMemHeightInInc?.value || 0,
        kgs: Number(formValues.memWeight) || 0,
      });
    } else {
      setBmiValues({});
    }
  }, [formValues.selMemHeightInFt, formValues.memWeight]);

  useEffect(() => {
    if (
      formValues.selMemHeightInCm?.value &&
      formValues.memWeight &&
      formValues.selMemAge?.value &&
      formValues.selGender?.value &&
      formValues.selActivity?.value
    ) {
      const calculatedTdee = calculateTDEE(
        parseFloat(formValues.memWeight || 0),
        parseFloat(formValues.selMemHeightInCm?.value || 0),
        parseFloat(formValues.selMemAge?.value || 0),
        parseFloat(formValues.selActivity?.value || 0),
        formValues.selGender?.value
      );

      setTdeeValues(calculatedTdee);
    } else {
      setTdeeValues(0);
    }
  }, [
    formValues.memWeight,
    formValues.selMemHeightInCm,
    formValues.selMemAge,
    formValues.selGender,
    formValues.selActivity,
  ]);

  useEffect(() => {
    if (
      formValues.selMemHeightInCm?.value &&
      formValues.memWeight &&
      formValues.selMemAge?.value &&
      formValues.selGender?.value
    ) {
      const calculatedBmr = calculateBMR(
        parseFloat(formValues.memWeight || 0),
        parseFloat(formValues.selMemHeightInCm?.value || 0),
        parseFloat(formValues.selMemAge?.value || 0),
        formValues.selGender?.value
      );

      setBmrValues(calculatedBmr);
    } else {
      setBmrValues(0);
    }
  }, [
    formValues.memWeight,
    formValues.selMemHeightInCm,
    formValues.selMemAge,
    formValues.selGender,
  ]);

  useEffect(() => {
    if (
      formValues.selMemHeightInCm?.value &&
      formValues.memWeight &&
      formValues.selMemAge?.value &&
      formValues.selGender
    ) {
      const calculatedBodyfat = calculateBodyFatPercentage(
        parseFloat(formValues.memWeight), // weight in kg
        parseFloat(formValues.selMemHeightInCm?.value), // height in cm
        parseFloat(formValues.selMemAge?.value), // age
        formValues.selGender?.value // gender
      );

      setBodyfatValues(calculatedBodyfat);
    } else {
      setBodyfatValues({});
    }
  }, [
    formValues.memWeight,
    formValues.selMemAge,
    formValues.selMemHeightInCm,
    formValues.selGender,
  ]);

  const bmiPercent = useMemo(() => {
    try {
      const bmi = Number(calculateBMI(bmiValues));
      const bmiRanges = [
        { min: 0, max: 18.5 },
        { min: 18.5, max: 24.9 },
        { min: 24.9, max: 29.9 },
        { min: 30, max: 40 },
      ];
      const arcLengthRatios = [0.2, 0.4, 0.2, 0.2];
      const { rangeIndex } = getBMICategory(bmi);

      if (rangeIndex !== -1) {
        const rangeWidth =
          bmiRanges[rangeIndex].max - bmiRanges[rangeIndex].min;
        const percentageWithinRange =
          (bmi - bmiRanges[rangeIndex].min) / rangeWidth;

        const isLastCategory = rangeIndex === arcLengthRatios.length - 1;
        const isBeyondLastCategory = bmi > bmiRanges[bmiRanges.length - 1].max;
        const percentage =
          isLastCategory || isBeyondLastCategory
            ? 1
            : arcLengthRatios[rangeIndex] * percentageWithinRange +
              arcLengthRatios
                .slice(0, rangeIndex)
                .reduce((acc, val) => acc + val, 0);

        return percentage;
      } else {
        return 0;
      }
    } catch (error) {
      console.log(error);
      return 0;
    }
  }, [bmiValues]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const calculatedBmi = calculateBMIForBodyFat(
        parseFloat(formValues.memWeight || 0),
        parseFloat(formValues.selMemHeightInCm?.value || 0)
      );
      const calculatedTotalDailyCalorie = calculateDailyCalorie(
        parseFloat(formValues.memWeight || 0),
        parseFloat(formValues.selMemHeightInCm?.value || 0),
        parseFloat(formValues.selMemAge?.value || 0),
        parseFloat(formValues.selGender?.value || 0),
        parseFloat(formValues.selActivity?.value || 0)
      );
      const calculatedTargetCalorie = calculateDailyCalorie(
        parseFloat(formValues.memTargetWeight || 0),
        parseFloat(formValues.selMemHeightInCm?.value || 0),
        parseFloat(formValues.selMemAge?.value || 0),
        parseFloat(formValues.selGender?.value || 0),
        parseFloat(formValues.selActivity?.value || 0)
      );

      const userDataFtProfileLog = {
        user_id: formValues.selMember?.info?.user_id || "",
        age: formValues.selMemAge?.value || 0,
        weight: formValues.memWeight || 0,
        target_weight: formValues.memTargetWeight || 0,
        height: formValues.selMemHeightInCm?.value || 0,
        gender: formValues.selGender?.value || "",
        type: formValues.selDietPreference?.value || "",
        body_type: formValues.selBodyType?.value || "",
        how_active: formValues.selActivity?.value || "",
        bmi_result: calculatedBmi || 0,
        fat_result: bodyfatValues?.bodyFatPercentage || 0,
        calorie_result: calculatedTotalDailyCalorie || 0,
        calorie_target_result: calculatedTargetCalorie || 0,
      };

      handleAdd(
        userDataFtProfileLog,
        "POST",
        fitnessProfileLogPut,
        "fitness-profile"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mealsModalContainer addMealModal">
      <CommonHeadingNBtns
        title={`${isFtProfileSuccess ? "Assign Diet" : "Add Fitness Profile"}`}
        onClose={onCloseModal}
        onClick={isFtProfileSuccess ? onAssignDiet : onSubmit}
        btnTxt={`${isFtProfileSuccess ? "Assign Diet" : "Next"}`}
        backBtnTxt={isFtProfileSuccess ? "Back" : ""}
        onClickBack={handleBack}
        noBtnTxt={notShowBtn}
        // noBtnTxt={isFtProfileSuccess && !(dataValues.dietPackData?.length > 0)}
      />

      {isFtProfileSuccess ? (
        <DietFetchAndAssign
          userInfoData={userInfoData}
          prevFormValues={formValues}
          dataValues={dataValues}
          tdeeValues={tdeeValues}
          setDataValues={setDataValues}
          recExtInputs={recExtInputs}
          setRecExtInputs={setRecExtInputs}
          isSubmit={isSubmitDF}
          setIsSubmit={setIsSubmitDF}
        />
      ) : (
        <form className="formContainer">
          <div className="formInputsGrid threeGridSystem">
            <div className="formInputBox">
              <label htmlFor="selMember" className="formInputLabel">
                Member *
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selMember ? "formError" : ""
                }`}
              >
                <SelectDropdownDynamic
                  options={members}
                  name={`Member`}
                  selectedOption={formValues.selMember}
                  setSelectedOption={(selectedOption) =>
                    onChangeDropdown(selectedOption, "selMember")
                  }
                  onSearchChange={handleSearchChange}
                  fetchMoreData={fetchMoreData}
                  fetchPreviousData={fetchPreviousData}
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="selGender" className={`formInputLabel `}>
                Member Gender *
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selGender ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={gender}
                  selectedOption={formValues.selGender}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selGender")
                  }
                  name="Gender"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="selMemAge" className={`formInputLabel `}>
                Member Age *
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selMemAge ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={ages}
                  selectedOption={formValues.selMemAge}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selMemAge")
                  }
                  name="Age"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="selMemHeightInFt" className={`formInputLabel `}>
                Member Height *
              </label>

              {formValues.isCmHeight ? (
                <div
                  className={`commonWrapper ${
                    formErrors?.selMemHeightInCm ? "formError" : ""
                  }`}
                >
                  <SelectDropdown
                    options={rangeDataUpto285}
                    selectedOption={formValues.selMemHeightInCm}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(selectedValue, "selMemHeightInCm")
                    }
                    name="Height In CM"
                  />
                </div>
              ) : (
                <div className="dual-form-input-box">
                  <div
                    className={`commonWrapper ${
                      formErrors?.selMemHeightInFt ? "formError" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={smallRangeDataUpto8}
                      selectedOption={formValues.selMemHeightInFt}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown(selectedValue, "selMemHeightInFt")
                      }
                      name="FT"
                      preventKeyboardOpen={true}
                    />
                  </div>

                  <div
                    className={`commonWrapper ${
                      formErrors?.selMemHeightInInc ? "formError" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={smallRangeDataUpto11}
                      selectedOption={formValues.selMemHeightInInc}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown(selectedValue, "selMemHeightInInc")
                      }
                      name="Inch"
                      preventKeyboardOpen={true}
                    />
                  </div>
                </div>
              )}

              <Form.Check
                type="switch"
                name="isCmHeight"
                className={`${formErrors?.isCmHeight ? "formError" : ""}`}
                label={`${formValues.isCmHeight ? "CM" : "FT/INCH"}`}
                checked={formValues.isCmHeight}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="memWaist" className="formInputLabel">
                Member Waist (Inch) *
              </label>

              <input
                type="number"
                className={`formInput ${formErrors.memWaist && "formError"}`}
                name="memWaist"
                placeholder="00.00"
                value={formValues.memWaist}
                onChange={onChangeInput}
                min={0}
              />
            </div>

            {/* <div className="formInputBox">
              <label htmlFor="memNeck" className="formInputLabel">
                Member Neck (Inch) *
              </label>

              <input
                type="number"
                className={`formInput ${formErrors.memNeck && "formError"}`}
                name="memNeck"
                placeholder="00.00"
                value={formValues.memNeck}
                onChange={onChangeInput}
                min={0}
              />
            </div> */}

            {/* <div className="formInputBox">
              <label htmlFor="memHip" className="formInputLabel">
                Member Hip (Inch) *
              </label>

              <input
                type="number"
                className={`formInput ${formErrors.memHip && "formError"}`}
                name="memHip"
                placeholder="00.00"
                value={formValues.memHip}
                onChange={onChangeInput}
                min={0}
              />
            </div> */}

            <div className="formInputBox">
              <label htmlFor="memWeight" className="formInputLabel">
                Member Current Weight (Kg) *
              </label>

              <input
                type="number"
                className={`formInput ${formErrors.memWeight && "formError"}`}
                name="memWeight"
                placeholder="0"
                value={formValues.memWeight}
                onChange={onChangeInput}
                min={0}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="memTargetWeight" className="formInputLabel">
                Member Target Weight (Kg) *
              </label>

              <input
                type="number"
                className={`formInput ${
                  formErrors.memTargetWeight && "formError"
                }`}
                name="memTargetWeight"
                placeholder="0"
                value={formValues.memTargetWeight}
                onChange={onChangeInput}
                min={0}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="selBodyType" className="formInputLabel">
                Member Diet Type *
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selBodyType ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={allDPDropdownData.allBodyTypes}
                  selectedOption={formValues.selBodyType}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selBodyType")
                  }
                  name="Diet Type"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="selDietPreference" className="formInputLabel">
                Member Diet Preference *
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selDietPreference && "formError"
                }`}
              >
                <SelectDropdown
                  options={allDPDropdownData.allDietPreferences}
                  selectedOption={formValues.selDietPreference}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selDietPreference")
                  }
                  name="Diet Preference"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>

            {/* <div className="formInputBox">
            <label htmlFor="selDietPreference" className="formInputLabel">
              Member Diet Preference *
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selDietPreference && "formError"
              }`}
            >
              <SelectDropdown
                options={allDPDropdownData.allDietPreferences}
                selectedOption={formValues.selDietPreference}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selDietPreference")
                }
                name="Diet Preference"
                preventKeyboardOpen={true}
              />
            </div>
          </div> */}

            <div className="formInputBox">
              <label htmlFor="selActivity" className="formInputLabel">
                Member Activity *
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selActivity && "formError"
                }`}
              >
                <SelectDropdown
                  options={fitnessProfileActivityStatuses}
                  selectedOption={formValues.selActivity}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selActivity")
                  }
                  name="Activity"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="selMedicalIssue" className="formInputLabel">
                Member Medical Condition(S) If Any
              </label>

              <div
                className={`commonWrapper no-border ${
                  formErrors.selMedicalIssue ? "formError" : ""
                }`}
              >
                <MultiSelect
                  options={medicalIssues}
                  state={formValues.selMedicalIssue}
                  setState={(selectedValue) =>
                    setFormValues((prevs) => ({
                      ...prevs,
                      selMedicalIssue: selectedValue,
                    }))
                  }
                  name="Medical Condition"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>

            {formValues.selMedicalIssue?.length > 0 &&
              formValues.selMedicalIssue?.some(
                (goal) => goal.value === "other"
              ) && (
                <div className="formInputBox twoInputs">
                  <label htmlFor="otherMedicalIssue" className="formInputLabel">
                    Member Other Medical Condition *
                  </label>
                  <input
                    type="text"
                    className={`formInput ${
                      formErrors?.otherMedicalIssue ? "formError" : ""
                    }`}
                    name="otherMedicalIssue"
                    placeholder="Enter Other Medical Option"
                    value={formValues.otherMedicalIssue}
                    onChange={onChangeInput}
                  />
                </div>
              )}

            <div className="formInputBox span3 check-input-not-bar flex-start flex-row">
              <Form.Check
                type="checkbox"
                name="isSmoke"
                className={`${formValues.isSmoke ? "formError" : ""}`}
                style={{
                  cursor: "pointer",
                }}
                label={`${formValues.isSmoke ? "Smoke" : "Smoke"}`}
                checked={formValues.isSmoke}
                onChange={onChangeInput}
              />

              <Form.Check
                type="checkbox"
                name="isDrink"
                className={`${formValues.isDrink ? "formError" : ""}`}
                style={{
                  cursor: "pointer",
                }}
                label={`${formValues.isDrink ? "Drink" : "Drink"}`}
                checked={formValues.isDrink}
                onChange={onChangeInput}
              />
            </div>
          </div>
        </form>
      )}

      <div className="member-bmi-calculations mt30">
        <div className="member-bmi-box form-charts-and-cards">
          <div className="bmiContainer">
            <p className="name">Member BMI</p>

            <div className="bmiBox">
              <div className="bmi-box-one bmiGraph">
                <GaugeChart
                  id="bmi-chart"
                  arcsLength={[0.2, 0.4, 0.2, 0.2]}
                  colors={["#1375d0", "#7ad34a", "#e2dd63", "#f13434"]}
                  percent={bmiPercent}
                  needleColor="#252525"
                  needleBaseColor="#252525"
                  animate={false}
                  arcWidth={0.4}
                  nrOfLevels={1}
                  textColor={"#252525"}
                  arcPadding={0}
                  cornerRadius={3}
                  hideText={true}
                />
                <div className="flex-k flex-col-k js-center-k items-center-k">
                  <p className="dark-text bold-text fs-4 lh-1">
                    {calculateBMI(bmiValues)}
                  </p>
                  <p className="text-muted">
                    {getBMICategory(calculateBMI(bmiValues))?.name || "N/A"}
                  </p>
                </div>
              </div>

              <div className="bmi-box-one bmiLegends">
                <div className="grayLine"></div>

                <div className="bmiLegendsItemContainer">
                  <div className="bmiLegendsItem">
                    <div className="bmiLegendsItemColor blue"></div>
                    <div className="calculations">
                      <p className="bmiLegendsItemText">Underweight</p>
                      <span className="bmiResult">Less than 18.5</span>
                    </div>
                  </div>
                  <div className="bmiLegendsItem">
                    <div className="bmiLegendsItemColor green"></div>
                    <div className="calculations">
                      <p className="bmiLegendsItemText">Healthy</p>
                      <span className="bmiResult">18.5 - 24.9</span>
                    </div>
                  </div>
                  <div className="bmiLegendsItem">
                    <div className="bmiLegendsItemColor orange"></div>
                    <div className="calculations">
                      <p className="bmiLegendsItemText">Overweight</p>
                      <span className="bmiResult">25.0 - 29.9</span>
                    </div>
                  </div>
                  <div className="bmiLegendsItem">
                    <div className="bmiLegendsItemColor red"></div>
                    <div className="calculations">
                      <p className="bmiLegendsItemText">Obese</p>
                      <span className="bmiResult">30.0 or higher</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="member-bmi-box  fat-bmr-tdee-container">
          <div className="fat-bmr-tdee">
            <div className="fbt-box">
              <div className="box-side left-side">
                <img src={BODYFAT} alt="body-fat" className="img" />
              </div>
              <div className="box-side right-side">
                <p className="value">
                  {bodyfatValues?.bodyFatPercentage || 0} %
                </p>
                <span className="label">Body Fat</span>
              </div>
            </div>
            <div className="fbt-box">
              <div className="box-side left-side">
                <img src={BMR} alt="bmr" className="img" />
              </div>
              <div className="box-side right-side">
                <p className="value">
                  {bmrValues} <small>Calories/Day</small>
                </p>
                <span className="label">BMR</span>
              </div>
            </div>
            <div className="fbt-box">
              <div className="box-side left-side">
                <img src={TDEE} alt="tdee" className="img" />
              </div>
              <div className="box-side right-side">
                <p className="value">
                  {tdeeValues} <small>Calories/Day</small>
                </p>
                <span className="label">TDEE</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FPForm;
